import {AbstractModel} from '../abstract-model';
import {Site} from '../site/site';
import {PageType} from '../page-type';
import {User} from '../user';

export class LandingPage extends AbstractModel {
  static readonly DETAILS_GROUP = 'landingPageDetails';

  id: number | null = null;
  name: string | null = null;
  url: string | null = null;
  external: boolean = false;
  enabled: boolean = false;
  offers: number[] = [];
  type: PageType | null = null;
  siteId: number | null = null;
  site: Site | null = null;
  user: User | null = null;
  createdAt: Date | null = null;
  updatedAt: Date | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.type) {
      this.type = new PageType().deserialize(input.type);
    }

    if (input.site) {
      this.site = new Site().deserialize(input.site);
    }

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    return this;
  }

  getShortUrl(): string {
    if (this.url && this.url.includes('?')) {
      return this.url.split('?')[0] + '(...)';
    }

    return this.url ?? '';
  }

  override toString(): string {
    return this.name ?? '';
  }
}
